
import { LoadState } from "../../constants/enums";
import { IOpportunities, IOpportunityState } from "./opportunites.types";


  export const defaultOpportunity:IOpportunities={
    opportunity_id: 0,
  opportunity_unique_id: 0,
  opportunity_uuid: "",
  leads_uuid: "",
  
  course_duration:"",
  leads_code: "",
  inquiry_date: "",
  organizations_uuid: "",
  organizations_name: "",
  batch: "",
  session_uuid:"",
  courses_uuid: "",
  academic_year: 0, 
  courses_name: "",
  customer_name: "",
  date_of_birth: "",
  email_id: null,
  gender: "",
  caste_category: "",
  seat_confirmation_fee: "",
  permanent_address: "",
  city: "",
  state: "",
  pincode: 0,
  country: "",
  contact_no: "",
  alternate_contact_no: "",
  remarks: "",
  inquiry_reference: "",
  followUp_date_and_remark: "",
  hostel_required: "",
  father_name: "",
  mother_name: "",
  parents_contact_no: "",
  annual_income: "",
  course_fee_structure: "",
  admission_date: null,
  qualifications: [],
  gap_year: null,
  fathers_occupation: null,
  mothers_occupation: null,
  family_income: null,
  aadhar_no: null,
  docs_upload: "",
  status: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  total_fee_amount: "",
  fees_paid: "",
  pending_fee: "",
  fee_type: "",
  }

  export const defaultOpportunityState: IOpportunityState = {
    list:{
        data: [],
        totalRecords: 0,
        loading: LoadState.InProgress,
        error: null,
    },
    opportunity:{
        data: defaultOpportunity,
        loading: LoadState.NotLoaded,
        error: null
    }
   
  };

  